import { Icon, Typography } from "@fullscript/aviary-web";
import type { IconDefinition } from "@fullscript/fontawesome-common-types";

import * as styles from "./FeatureRow.styles";

interface Props {
  icon: IconDefinition;
  title: string;
  description: string;
}

const FeatureRow = ({ icon, title, description }: Props) => (
  <div css={styles.row}>
    <div css={styles.iconContainer}>
      <Icon icon={icon} size="xsmall" />
    </div>
    <div css={styles.textStack}>
      <Typography
        variant="callout"
        fontWeight="bold"
        isMarginless
        colorIntensity="bold"
        intention="inverse"
      >
        {title}
      </Typography>
      <Typography variant="footnote" isMarginless intention="inverse">
        {description}
      </Typography>
    </div>
  </div>
);

export { FeatureRow };
